import { useEffect, useRef, useState } from 'react';

import { apiUrl, fetchJson } from '../../apiBase';

const useMaarifAssessments = ({ activityId, notifyError }) => {
  const [assessments, setAssessments] = useState([]);
  const [loadingAssessments, setLoadingAssessments] = useState(false);
  const reqIdRef = useRef(0);

  useEffect(() => {
    setAssessments([]);
    setLoadingAssessments(false);

    if (!activityId) return;

    const rid = ++reqIdRef.current;
    const run = async () => {
      try {
        setLoadingAssessments(true);
        const res = await fetchJson(
          apiUrl(`/admin/maarif/learning-activities/${encodeURIComponent(activityId)}/assessments`)
        );
        if (rid !== reqIdRef.current) return;
        if (!res.ok) throw new Error('assessments');
        const rows = await res.json();
        const items = (rows || [])
          .filter((r) => r && r.id != null)
          .map((r) => ({
            id: r.id,
            learning_activity_id: r.learning_activity_id,
            name: String(r.name || ''),
          }))
          .filter((r) => r.name);
        setAssessments(items);
      } catch (e) {
        if (rid !== reqIdRef.current) return;
        notifyError && notifyError('Rubrikler yüklenemedi');
        setAssessments([]);
      } finally {
        if (rid !== reqIdRef.current) return;
        setLoadingAssessments(false);
      }
    };

    run();
  }, [activityId, notifyError]);

  return { assessments, loadingAssessments };
};

export default useMaarifAssessments;
